import { jsx } from "panel";
import { MarkdownEl } from "common/components/markdown";
import { DisplaySize } from "./types";
export function template() {
  var _a;
  const { visibility } = this.state;
  const imageUrl = this.attr(`image-src`);
  const text = this.attr(`text`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-tooltip",
    class: {
      "is-tooltip-tour": this.attr(`is-tooltip-tour`),
      "has-max-width": this.attr(`max-width`) !== null || this.attr(`size`) !== DisplaySize.Fit,
      "is-animated": this.helpers.shouldAnimateTooltip(),
      "has-image": !!imageUrl,
      [`is-${visibility}`]: true,
      [`size-${this.attr(`size`)}`]: true,
      "break-word": this.attr(`break-word`)
    },
    style: this.attr(`max-width`) && {
      "max-width": this.attr(`max-width`),
      hyphens: `auto`
    },
    on: {
      click: this.helpers.stopPropagation,
      mousedown: this.helpers.stopPropagation
    }
  }, imageUrl && /* @__PURE__ */ jsx("img", {
    sel: ".mp-tooltip-image",
    attrs: { src: imageUrl }
  }), /* @__PURE__ */ jsx("slot", null), text && visibility !== this.helpers.VISIBILITY_HIDDEN && /* @__PURE__ */ jsx(MarkdownEl, {
    sel: ".mp-tooltip-text",
    attrs: { text }
  }), visibility !== this.helpers.VISIBILITY_HIDDEN && ((_a = this.lazyContentRenderer) == null ? void 0 : _a.call(this)), this.attr(`is-tooltip-tour`) ? null : /* @__PURE__ */ jsx("div", {
    sel: ".mp-tooltip-arrow"
  }));
}
